import { parseDate } from "../../utils/helpers";

export const DateCell = ({
	availability,
	onDateSelected,
	dateInfo,
	disabled,
	highlighted,
}) => {
	//hide the non selectable cell dates from the voice assistant

	const id = parseDate("yyyy-mm-dd", dateInfo.dateObject);
	const dynamicClassName = `${dateInfo.isWeekend ? "weekend" : ""} ${
		dateInfo.isToday ? "today" : ""
	} ${dateInfo.isSelected ? "selected" : ""} ${
		highlighted ? "highlighted" : ""
	} ${dateInfo.isBeforeToday ? "before-today" : ""}`;
	const hiddenCell = {
		"aria-hidden": true,
		"aria-disabled": true,
	};
	/* -------------------------------------------------------------------
     | INVISIBLE DATE CELL
     -------------------------------------------------------------------- */
	/* -------------------------------------------------------------------`
     | DISABLED DATE CELL
     -------------------------------------------------------------------- */
	if (dateInfo.isBeforeMonthStart || dateInfo.isAfterMonthEnd)
		return (
			<td
				id={id}
				role="cell"
				className="cell hidden disabled day w-100"
				{...hiddenCell}
			></td>
		);
	if (
		dateInfo.isBeforeToday ||
		disabled ||
		!availability ||
		dateInfo.isWeekend
	)
		return (
			<td
				id={id}
				role="cell"
				className={`cell disabled day w-100 h-100 r3 df fd-c jcsb aifs ${dynamicClassName}`}
				{...hiddenCell}
			>
				<span
					className="day-container h-100  df aifs fd-c jcsb"
					aria-hidden
				>
					<p className="text s24-500 left">
						{parseDate("d", dateInfo.dateObject)}
					</p>
				</span>
			</td>
		);

	/* -------------------------------------------------------------------
     | DEFAULT DATE CELL
     -------------------------------------------------------------------- */

	return (
		<td
			id={id}
			className={`button b-0 p-0 cell day w-100 h-100 r3 df fd-c jcsb aifs p-r ${dynamicClassName} outline-shadow`}
			role="cell"
		>
			<button
				className="w-100 h-100"
				aria-label={`${parseDate(
					"Monday d November yyyy",
					dateInfo.dateObject
				)}`}
				onPointerDown={() =>
					onDateSelected(parseDate("yyyy-mm-dd", dateInfo.dateObject))
				}
			>
				<span
					className="day-container h-100 df aifs jcsb fd-c"
					aria-hidden
				>
					<p className="text s24-500 left">
						{parseDate("d", dateInfo.dateObject)}
					</p>
				</span>
			</button>
		</td>
	);
};
